const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/utils/translations.ts';
import { defineMessages } from './intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        unit_2: 'Sekunden',
        unit_3: 'Minuten',
        unit_4: 'Stunden',
        unit_5: 'Tage',
        unit_6: 'Wochen',
        unit_7: 'Monate',
        unit_8: 'Jahre',
        A: 'Alimentäres System und Stoffwechsel (A)',
        B: 'Blut und blutbildende Organe (B)',
        C: 'Kardiovaskuläres System (C)',
        D: 'Dermatika (D)',
        G: 'Urogenitalsystem und Sexualhormone (G)',
        H: 'Hormonpräparate systemisch (H)',
        J: 'Antiinfektiva systemisch (J)',
        L: 'Antineoplastische und immunmodulierende Substanzen (L)',
        M: 'Muskel- und Skelettsystem (M)',
        N: 'Nervensystem (N)',
        P: 'Antiparasitäre Mittel, Insektizide, Repellenzien (P)',
        R: 'Respirationstrakt (R)',
        S: 'Sinnesorgane (S)',
        V: 'Varia (V)',
        otherATCCode: 'Andere Medikamente ATC',
        noATCCode: 'Medikamente ohne ATC-Code',
    },
    __RELATIVE_SOURCE_FILE__
);
